import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const NAME_MAX = 100;

export const createUserSchema = z.object({
  first_name: z
    .string()
    .trim()
    .min(1, "First name is required")
    .max(NAME_MAX, `Max ${NAME_MAX} chars`),

  last_name: z
    .string()
    .trim()
    .min(1, "Last name is required")
    .max(NAME_MAX, `Max ${NAME_MAX} chars`),

  emp_id: z
    .string()
    .trim()
    .min(1, "Employee Id is required")
    .max(100, "Max 100 chars"),

  mobile: z
    .string()
    .trim()
    .min(1, "Mobile number is required")
    .regex(/^[0-9]{7,15}$/, "Enter valid mobile number"),

  email: z
    .string()
    .trim()
    .min(1, "Email is required")
    .email("Enter valid email"),

  birth_date: z
    .string()
    .min(1, "Date of birth is required")
    .refine((s) => !Number.isNaN(Date.parse(s)), "Invalid date")
    .refine((s) => new Date(s) <= new Date(), "Date of birth cannot be in the future"),

  role_id: z.number({ required_error: "Role is required" }),
});
